import { createContext } from "react"

const NotificationsContext = createContext({})

const { Provider, Consumer } = NotificationsContext

export { Provider, Consumer, NotificationsContext }
